"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["CHAT_NEW_MESSAGE"] = "CHAT_NEW_MESSAGE";
    NotificationType["CHAT_NEW_MESSAGE_GROUPED"] = "CHAT_NEW_MESSAGE_GROUPED";
    NotificationType["EXTERNAL_CHAT_NEW_MESSAGE"] = "EXTERNAL_CHAT_NEW_MESSAGE";
    NotificationType["EXTERNAL_CHAT_NEW_MESSAGE_GROUPED"] = "EXTERNAL_CHAT_NEW_MESSAGE_GROUPED";
    NotificationType["FILE_CREATED"] = "FILE_CREATED";
    NotificationType["FILE_CREATED_GROUPED"] = "FILE_CREATED_GROUPED";
    NotificationType["FOLDER_ARCHIVED"] = "FOLDER_ARCHIVED";
    NotificationType["FOLDER_UNARCHIVED"] = "FOLDER_UNARCHIVED";
    NotificationType["FOLDER_DELETED"] = "FOLDER_DELETED";
    NotificationType["FOLDER_INVITATION_CREATED"] = "FOLDER_INVITATION_CREATED";
    NotificationType["FOLDER_RESTORED"] = "FOLDER_RESTORED";
    NotificationType["PROJECTS_ARCHIVED"] = "PROJECTS_ARCHIVED";
    NotificationType["PROJECTS_UNARCHIVED"] = "PROJECTS_UNARCHIVED";
    NotificationType["PROJECTS_DELETED"] = "PROJECTS_DELETED";
    NotificationType["PROJECTS_RESTORED"] = "PROJECTS_RESTORED";
    NotificationType["PROJECT_ARCHIVED"] = "PROJECT_ARCHIVED";
    NotificationType["PROJECT_UNARCHIVED"] = "PROJECT_UNARCHIVED";
    NotificationType["PROJECT_DELETED"] = "PROJECT_DELETED";
    NotificationType["PROJECT_RESTORED"] = "PROJECT_RESTORED";
    NotificationType["INVITATION_CREATED"] = "INVITATION_CREATED";
    NotificationType["PROJECT_INVITATION_CREATED"] = "PROJECT_INVITATION_CREATED";
    NotificationType["TASK_CREATED"] = "TASK_CREATED";
    NotificationType["TASK_ASSIGNED"] = "TASK_ASSIGNED";
    NotificationType["TASK_DONE"] = "TASK_DONE";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=NotificationType.js.map